export const AVERAGE_VIDEO_GENERATION_IN_MILLISECONDS = 5 * 60 * 1000;

export const VIDEO_WITH_WATERMARK_SUFFIX = '_w_';

export const ESTIMATED_ANIMATE_ASSET_DURATION = 30;
